export enum SpendType {
  ALL = 'all',
  STRATEGIC_SPEND = 'strategicSpend',
  TAIL_SPEND = 'tailSpend',
}
